export const COUNTRY_CODES = {
	US: 'US',
	CA: 'CA',
	GB: 'GB',
	CH: 'CH',
	AU: 'AU',
	JP: 'JP',
	BR: 'BR',
	CN: 'CN',
	DE: 'DE',
	FR: 'FR',
	IT: 'IT',
	ES: 'ES',
	NL: 'NL',
	BE: 'BE',
	AT: 'AT',
	SE: 'SE',
	DK: 'DK',
	FI: 'FI',
	IE: 'IE',
	PT: 'PT',
	PL: 'PL',
	CZ: 'CZ',
	HU: 'HU',
	RO: 'RO',
	BG: 'BG',
	HR: 'HR',
	SK: 'SK',
	SI: 'SI',
	EE: 'EE',
	LV: 'LV',
	LT: 'LT',
	LU: 'LU',
	MT: 'MT',
	CY: 'CY',
	GR: 'GR',
} as const

export type CountryCode = (typeof COUNTRY_CODES)[keyof typeof COUNTRY_CODES]

export const COUNTRY_CODE_VALUES = [
	COUNTRY_CODES.US,
	COUNTRY_CODES.CA,
	COUNTRY_CODES.GB,
	COUNTRY_CODES.CH,
	COUNTRY_CODES.AU,
	COUNTRY_CODES.JP,
	COUNTRY_CODES.BR,
	COUNTRY_CODES.CN,
	COUNTRY_CODES.DE,
	COUNTRY_CODES.FR,
	COUNTRY_CODES.IT,
	COUNTRY_CODES.ES,
	COUNTRY_CODES.NL,
	COUNTRY_CODES.BE,
	COUNTRY_CODES.AT,
	COUNTRY_CODES.SE,
	COUNTRY_CODES.DK,
	COUNTRY_CODES.FI,
	COUNTRY_CODES.IE,
	COUNTRY_CODES.PT,
	COUNTRY_CODES.PL,
	COUNTRY_CODES.CZ,
	COUNTRY_CODES.HU,
	COUNTRY_CODES.RO,
	COUNTRY_CODES.BG,
	COUNTRY_CODES.HR,
	COUNTRY_CODES.SK,
	COUNTRY_CODES.SI,
	COUNTRY_CODES.EE,
	COUNTRY_CODES.LV,
	COUNTRY_CODES.LT,
	COUNTRY_CODES.LU,
	COUNTRY_CODES.MT,
	COUNTRY_CODES.CY,
	COUNTRY_CODES.GR,
] as const

export const DEFAULT_COUNTRY_CODE: CountryCode = COUNTRY_CODES.US

export function isCountryCode(value: unknown): value is CountryCode {
	return (
		typeof value === 'string' &&
		(COUNTRY_CODE_VALUES as readonly string[]).includes(value)
	)
}
